import React from "react";
import { Outlet } from "react-router-dom";
import BeneficiaryHeader from "./components/BeneficiaryHeader";

function index(props) {
  // location.reload()
  return (
    <>
      <Outlet />
    </>
  );
}

export default index;
